import type { ReactNode } from "react";
import styles from "./Container.module.css";

interface Props {
  children: ReactNode;
  narrow?: boolean;
  className?: string;
}

/** Single place the page gutter and max width are decided. */
export function Container({ children, narrow = false, className }: Props) {
  return (
    <div className={[styles.container, narrow && styles.narrow, className].filter(Boolean).join(" ")}>
      {children}
    </div>
  );
}
